<template>
  <div id="#step-4" class="fade-in-fwd text-center">
    <!-- Tab section -->
    <div class="mt-3 mb-4">
      <button
        v-for="tab in tabs"
        :key="tab.label"
        class="btn btn-tab btn-tab-sm ml-2 mr-2"
        @click="handleTabChange(tab.value)"
        :class="selectedTab == tab.value ? 'active selected-tab' : ''"
      >
        {{ tab.label }}
      </button>
    </div>

    <!-- Gallery Images -->
    <div v-show="selectedTab === 'Gallery'">
      <div class="row mt-2" v-if="images.length > 0">
        <div class="col-sm-4" v-for="image in images" :key="image.embedId">
          <div
            @click="updateImage(image.embedId, gallery, image.imageAltText)"
            class="swiper-slide swiper-slide-visible swiper-slide-active mb-2"
            :class="
              image.embedId == roomSceneId
                ? 'my-project-feature-image-active'
                : ''
            "
          >
            <div class="wf-product-quick-view-swatch-slide">
              <div class="wf-product-quick-view-swatch-slide-image">
                <img
                  class="room-img-thumb"
                  :src="getImageUrl(image.embedId, 500, gallery)"
                  :alt="image.imageAltText || ''"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <pc-load-more v-if="showLoadMore" :load-more="onLoadMore" />
      <div
        v-else-if="!showLoadMore && images.length == 0"
        class="container text-center mt-5 mb-5"
      >
        <p class="">{{ $resourceString["common.NoDataAvailable.Msg"] }}</p>
      </div>
    </div>

    <!-- Roomscene Images -->
    <div v-show="selectedTab === 'Room'">
      <!-- color selection -->

      <div class="swatch-image-section row">
        <div class="col-md-12 text-justify">
          <label
            for="choose_color"
            class="font-weight-bold font-16 text-uppercase"
            >{{ $resourceString["myProject.Product.SelectColor.Label"] }}</label
          >
        </div>
        <div
          class="col-2 swatch-image-item px-2 mt-2"
          v-for="color in getContentWizardData.step3"
          :key="color.id"
        >
          <button
            @click="updateColor(color)"
            type="button"
            class="btn wf-product-room-scene-color-item-button"
            :class="
              color.colorNumber == selectedColorNumber
                ? 'wf-product-room-scene-color-item-button-active'
                : 'wf-product-room-scene-color-item-button-disabled'
            "
          >
            <img :src="color.imageLink" alt="" class="w-100 h-100" />
          </button>
        </div>
      </div>
      <div class="swatch-image-section row mt-2 mb-2" v-if="installationMethod && installationMethod != 'default'">
        <div class="col-md-12 text-justify">
          <label
            for="installation"
            class="font-weight-bold font-16 text-uppercase"
            >{{
              $resourceString["myProject.Product.InstallationMethod.Label"]
            }}</label
          >
        </div>
        <div class="col-md-12">
          <select
            @change="handleInstallation"
            name="productType"
            :id="installationMethod"
            class="form-control form-control-sm text-uppercase"
            required="required"
            v-model="installationMethod"
          >
            <option
              class="dropdown-item"
              v-for="(item, index) in getSelectedProduct.installationMethods"
              :key="index"
              :value="item.name"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row mt-2" v-if="step4.length > 0">
        <div class="col-sm-4" v-for="(item, index) in step4" :key="index">
          <div
            @click="updateImage(item, null, '')"
            class="swiper-slide swiper-slide-visible swiper-slide-active mb-2"
            :class="
              item == roomSceneId ? 'my-project-feature-image-active' : ''
            "
          >
            <div class="wf-product-quick-view-swatch-slide">
              <div class="wf-product-quick-view-swatch-slide-image">
                <img
                  class="room-img-thumb"
                  :src="getImageUrl(item, 1000, null)"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="container text-center mt-5">
        <p class="">{{ $resourceString["common.NoDataAvailable.Msg"] }}</p>
      </div>
    </div>

    <!-- Swatches -->
    <div v-show="selectedTab === 'Swatches'">
      <div class="row mt-2" v-if="getContentWizardData.step3.length > 0">
        <div
          class="col-sm-4"
          v-for="color in getContentWizardData.step3"
          :key="color.id"
        >
          <div
            @click="updateSwatchesImage(color)"
            class="swiper-slide swiper-slide-visible swiper-slide-active mb-2"
            :class="
              color.imageLink == imgUrl ? 'my-project-feature-image-active' : ''
            "
          >
            <div class="wf-product-quick-view-swatch-slide">
              <div class="wf-product-quick-view-swatch-slide-image">
                <img class="room-img-thumb" :src="color.imageLink" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="container text-center mt-5">
        <p class="">{{ $resourceString["common.NoDataAvailable.Msg"] }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import WFLoadImage from "../../wf-load-image.vue";
import PcLoadMore from "../../common/pc-loading-more.vue";
export default {
  components: {
    "wf-load-image": WFLoadImage,
    PcLoadMore
  },
  data() {
    return {
      step4: [],
      roomSceneId: "",
      imgpath: "",
      imgAltText: "",
      installationMethod: null,
      selectedColorNumber: "",
      gallery: this.$resourceString[
        "myProject.Project.AddItemModal.ProductStep4.ConditionalWord"
      ],
      imgUrl: null,
      tabs: [
        {
          value: "Gallery",
          label: this.$resourceString["myProject.Product.GalleryPhoto.Label"] //"Gallery Photo"
        },

        {
          value: "Room",
          label: this.$resourceString[
            "inspiration.display.control.sort.by.room"
          ] // "Room Scenes"
        },
        {
          value: "Swatches",
          label: this.$resourceString["myProject.Product.Swatches.Label"] //"Swatches"
        }
      ],
      selectedTab: "Gallery"
    };
  },

  computed: {
    ...mapGetters({
      getContentWizardData: "contentWizard/getContentWizardData",
      getSelectedProduct: "contentWizard/getSelectedProduct",
      images: "contentWizard/getinspirationGalleryImages",
      showLoadMore: "contentWizard/getShowLoadMore",
      isFetching: "contentWizard/getLoader",
    }),
  },

  created() {
    this.changeInspiration();
    this.step4 = this.getSelectedProduct.roomsceneIds;
    // Set the first color as the default selected color
    if (this.getContentWizardData.step3.length > 0) {
      const firstColor = this.getContentWizardData.step3[0];
      this.selectedColorNumber = firstColor.colorNumber;
      this.setSelectedColorNumber(firstColor.colorNumber);
    }
    if (this.getContentWizardData.selectedRoomSceneId) {
      this.roomSceneId = this.getContentWizardData.selectedRoomSceneId;
      this.setSelectedRoomScene(this.roomSceneId);
    }
  },

  mounted() {
    this.installationMethod = this.getSelectedProduct.installationMethods[0]?.name;
    if (this.getContentWizardData.productItemDetails?.coverPhoto) {
      // Get the color number from the URL
      this.imgUrl = this.getContentWizardData.productItemDetails?.coverPhoto;
      if (this.imgUrl.includes("/colors/") && this.imgUrl.includes("/rooms/")) {
        // Case 1: URL contains color and room scene information
        const match = this.imgUrl.match(/\/colors\/(\d+)\/rooms\/(\d+)\/installs\/([^/?]+)/);
        if (match?.length > 0) {
          this.selectedColorNumber = match[1];
          this.setSelectedColorNumber(this.selectedColorNumber);
          this.roomSceneId = match[2];
          this.setSelectedRoomScene(this.roomSceneId);
          this.installationMethod = match[3];
          this.selectedTab = "Room";
        }
      } else if(this.imgUrl.includes("/colors/") && !this.imgUrl.includes("/rooms/")){
        // Case 2: For Swatches
        this.selectedTab = "Swatches";
      }else {
        // Case 3: URL contains a different format
        const match = this.imgUrl.match(/\/content\/([^\/]+)\/png/);
        if (match?.length > 0) {
          this.roomSceneId = match[1];
          this.images.filter(image => {
            image.embedId === this.roomSceneId;
          });
          this.selectedTab = "Gallery"
        }
      }
      this.setContentItem({ coverPhoto: this.imgUrl, coverPhotoImageAltText: this.imgAltText });
    }

    // Set the first color as the default selected color
    if (this.getContentWizardData.step3.length > 0) {
      const firstColor = this.getContentWizardData.step3[0];
      this.selectedColorNumber = firstColor.colorNumber;
      this.setSelectedColorNumber(firstColor.colorNumber);
    }
    if (this.getContentWizardData.selectedRoomSceneId) {
      this.roomSceneId = this.getContentWizardData.selectedRoomSceneId;
      this.setSelectedRoomScene(this.roomSceneId);
    }
  },

  watch: {
    imgpath: {
      handler: function(newImgPath, oldImgPath) {
        if (newImgPath !== oldImgPath) {
          this.setContentItem({ coverPhoto: newImgPath });
        }
      }
    },
    imgAltText: {
      handler: function(newImgAltText, oldImgAltText) {
        if (newImgAltText !== oldImgAltText) {
          this.setContentItem({ coverPhotoImageAltText : newImgAltText });
        }
      }
    },
    selectedColorNumber: {
      handler: function(newColorNumber, oldColorNumber) {
        if (
          newColorNumber !== oldColorNumber &&
          (this.imgUrl?.includes("/installs/") || this.getContentWizardData.contentItem.coverPhoto?.includes("/installs/"))
        ) {
          this.updateImgAltText("")
          this.updateImgPath(null);
        }
      }
    },
    selectedTab: {
    handler: function(newTab, oldTab) {
      if (!newTab) {
        this.selectedTab = 'Gallery';
      }
    }
  }
  },

  methods: {
    ...mapActions({
      setContentItem: "contentWizard/setContentItem",
      setSelectedColorNumber: "contentWizard/setSelectedColorNumber",
      setSelectedRoomScene: "contentWizard/setSelectedRoomScene",
      fetchImageResults: "contentWizard/fetchImageResults"
    }),

    onLoadMore() {
      if (this.isFetching) {
        return;
      }
    },

    async handleInstallation(){
      if(this.getContentWizardData.contentItem.coverPhoto?.includes("/installs/")){
         await this.updateImgAltText("")
         await this.updateImgPath(null);
         await this.setContentItem({ coverPhoto: this.imgpath, coverPhotoImageAltText : this.imgAltText});
      }

    },

    handleTabChange(tabName) {
      this.selectedTab = tabName;
    },

    async changeInspiration() {
      this.fetchImageResults({
        filter: {
          OrderColumn: "DisplayCollectionName",
          SortBy: "DisplayCollectionName",
          PageNumber: 1,
          IncludeTotalResultCount: true,
          PageSize: 400,
          SearchTerm: this.getSelectedProduct.styleNumber,
          IsAscendingOrder: true
        },
        includefilters: true
      });
    },

    getImageUrl(id, size, type) {
      if (type == this.gallery) {
        return this.$helpers.getWidenImgURL(id, 1000);
      } else {
        return this.$helpers.getInteractiveRoomSceneImageUrl(
          this.getSelectedProduct.styleNumber,
          this.getContentWizardData.selectedColorNumber
            ? this.getContentWizardData.selectedColorNumber
            : this.getContentWizardData.step3[0]?.colorNumber,
          id,
          this.installationMethod ?? "default",
          size,
          this.getSelectedProduct.productTypeDesc,
          this.getSelectedProduct.inventoryType
        );
      }
    },

    updateImage(roomSceneId, type, imgAltText) {
      if (roomSceneId) {
        this.roomSceneId = roomSceneId;
        this.setSelectedRoomScene(roomSceneId);
        this.updateImgAltText(imgAltText)
        this.updateImgPath(type);
      } else {
        this.roomSceneId = "";
      }
    },

    updateSwatchesImage(data) {
      if (data.colorNumber) {
        this.roomSceneId = data.colorNumber;
        this.setSelectedRoomScene(data.colorNumber);
        this.imgpath = data.imageLink;
        this.imgUrl = data.imageLink;
        this.updateImgAltText("")
      } else {
        this.roomSceneId = "";
      }
    },
    updateImgAltText(altText) {
      this.imgAltText = altText || ''
    },
    updateImgPath(type) {
      const newImgPath = this.getImageUrl(this.roomSceneId, 1000, type);
      if (newImgPath !== this.imgpath) {
        this.imgpath = newImgPath;
      }
    },
    updateColor(data) {
      if (data) {
        this.selectedColorNumber = data.colorNumber;
        this.setSelectedColorNumber(data.colorNumber);
      } else {
        this.selectedColorNumber = "";
      }
    }
  }
};
</script>
